



















































import { Vue, Component, Prop } from 'vue-property-decorator';
import BaseHelpMessage from '../base-help-message/_base-help-message.vue';
import InvalidIllustration from '../../assets/icons/editor-image-not-supported.svg';
import DefaultIllustration from '../../assets/icons/default-file-icon.svg';
import { IDropzoneLocalization } from '../base-dropzone/types/dropzone-localization';

@Component({
  name: 'BaseDropzone',
  components: {
    BaseHelpMessage,
    DefaultIllustration,
    InvalidIllustration,
  },
})
export default class BaseDropzone extends Vue {
  @Prop({ default: false }) error: boolean;
  @Prop({ default: '' }) helpMessage: string;
  @Prop() acceptedFileTypes: string;
  @Prop() image: string;
  @Prop() maxSize: number;
  @Prop() disabled: boolean;
  @Prop() localization!: IDropzoneLocalization;

  internalError = false;
  internalHelpMessage = '';
  inputFile: File = null;
  validFile = true;

  handleFileInput(event: Event) {
    if (this.disabled) {
      return;
    }
    const { files } = event.target as HTMLInputElement;

    if (!files) {
      return;
    }

    this.inputFile = files[0];
    this.validFile = this.validateFileType(this.inputFile);

    if (!this.inputFile || !this.validFile) {
      this.$emit('invalidFile');
      return;
    }
    this.$emit('selectFile', this.inputFile);
  }

  handleDrop(event: DragEvent) {
    if (this.disabled) {
      return;
    }
    if (!event.dataTransfer) {
      return;
    }
    this.inputFile = event.dataTransfer.files[0];

    this.validFile = this.validateFileType(this.inputFile);

    if (!this.inputFile || !this.validFile) {
      this.$emit('invalidFile');
      return;
    }
    this.$emit('selectFile', this.inputFile);
  }

  created() {
    this.internalHelpMessage = this.helpMessage;
  }

  validateFileType(inputFile: File): boolean {
    const fileName: string = inputFile.name;
    const dotIndex: number = fileName.lastIndexOf('.');
    if (dotIndex < 0) {
      return false;
    }
    const fileType: string = fileName.substr(dotIndex);

    return this.acceptedFileTypes.includes(fileType);
  }

  get validUploadedFile(): boolean {
    return !!this.inputFile && this.validFile;
  }
}
